import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
    StateService,
    AuthService,
    AnalyticsService
} from '../../../services';
import { AppConfig } from '../../../config';
import { UserModel } from '../../../models';
import { ModalResetPasswordComponent } from '../../../shared/modals'
import { forkJoin } from 'rxjs';

@Component({
    selector: 'auctions-layout',
    styleUrls: ['./auctions-layout.component.scss'],
    templateUrl: './auctions-layout.component.html'
})
export class AuctionsLayoutComponent implements OnInit {

    constructor(private appConfig: AppConfig, private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title, private modalService: NgbModal, private analyticsService: AnalyticsService, public stateService: StateService, public authService: AuthService) {
        var me = this;
    }

    ngOnInit() {
        let me = this;
    }

}
